// extracted by css-extract-rspack-plugin
module.exports =  {"news":"NewsListItem-WpD1__news","header-image":"NewsListItem-Yjr0__header-image","title":"NewsListItem-XgNN__title"};